export default "If you have any questions, please see our [FAQ.](https://help.carma.com.au/hc/en-us)\n";